<template>
    <div style="display: flex;
    min-height: 100vh;
    flex-direction: column;">
        <div class="header">
            <div class="">
                <div class="header-content">
                    <a class="logo-link" href="http://www.kolumbus.no">
                        <img src="../assets/images/site-logo.svg" />
                    </a>
                    <div class="site-top-menu" v-bind:class="{ 'hidden-mobile': !nav_bar_visible }">
                        <div class="site-navigation">
                            <div class="site-navigation-menu">
                                <div v-if="authenticated" class="menu-item visible-mobile-sm">
                                    <a href="#" v-on:click.prevent="signOut()">
                                        <div
                                            style="display: flex; align-items: center; justify-content:flex-end; padding-right: 8px;">
                                            <span class="material-symbols-outlined">
                                                logout
                                            </span>

                                            <span style="padding-left: 8px;">
                                                {{ $t('header.sign_out') }}
                                            </span>

                                        </div>
                                    </a>
                                </div>
                                <div class="menu-item">
                                    <a v-bind:href="`/${app_locale}/terms`">
                                        {{ $t('header.link_terms') }}
                                    </a>
                                </div>
                                <div class="menu-item">
                                    <a v-bind:href="`/${app_locale}/cancellation`">
                                        {{ $t('header.link_term_cancellation') }}
                                    </a>
                                </div>
                                <div class="menu-item">
                                    <a v-bind:href="`/${app_locale}/change`">
                                        {{ $t('header.link_term_change') }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spacer"></div>
                    <div class="header-right">
                        <div class="navbar-tool">
                            <a v-bind:href="`/${app_locale}`">
                                <div class="navbar-icon hidden-mobile-sm">
                                    <img style="width: 12px;" src="../assets/images/home.svg" />
                                </div>
                                <span class="icon-text hidden-mobile-sm">
                                    {{ $t('header.ticket') }}
                                </span>
                                <div class="icon-mobile visible-mobile-sm">
                                    <span class="material-symbols-outlined">
                                        home
                                    </span>
                                </div>
                            </a>
                        </div>
                        <template v-if="authenticated">
                            <div class="navbar-tool hidden-mobile-sm">
                                <a href="#" v-on:click.prevent="signOut()">
                                    <div class="navbar-icon">
                                        <img style="width: 12px;" src="../assets/images/logout.svg" />
                                    </div>
                                    <span class="icon-text">
                                        {{ $t('header.sign_out') }}
                                    </span>
                                </a>
                            </div>
                            <div class="navbar-tool">
                                <a v-bind:href="`/${app_locale}/account`">
                                    <div class="navbar-icon hidden-mobile-sm">
                                        <img style="width: 12px;" src="../assets/images/person.svg" />
                                    </div>
                                    <span class="icon-text hidden-mobile-sm">
                                        {{ $t('header.my_account') }}
                                    </span>
                                    <div class="icon-mobile visible-mobile-sm">
                                        <span class="material-symbols-outlined">
                                            account_circle
                                        </span>
                                    </div>
                                </a>
                            </div>

                        </template>
                        <template v-else>
                            <!-- <div class="navbar-tool">
                                    <a v-bind:href="`/${app_locale}/signup`" style="margin-right:10px;">{{
                                        $t('header.signup') }}</a>
                                </div> -->
                            <div class="navbar-tool">
                                <a href="#" onclick="document.getElementById('n1-signin-modal').style.display='block'">
                                    <div class="navbar-icon hidden-mobile-sm">
                                        <img style="width: 12px;" src="../assets/images/person.svg" />
                                    </div>
                                    <span class="icon-text hidden-mobile-sm">
                                        {{ $t('header.signin') }}
                                    </span>
                                    <div class="icon-mobile visible-mobile-sm">
                                        <span class="material-symbols-outlined">
                                            account_circle
                                        </span>
                                    </div>
                                </a>
                            </div>
                        </template>
                        <div class="navbar-tool">
                            <a href="#" v-on:click="changeLanguage()">
                                <div class="navbar-icon hidden-mobile-sm">
                                    <!-- <span class="material-symbols-outlined">flag</span> -->
                                    <img style="width: 12px;" src="../assets/images/flag.svg" />
                                </div>
                                <span class="icon-text hidden-mobile-sm">
                                    {{ the_other_language }}
                                </span>
                                <div class="icon-mobile visible-mobile-sm">
                                    <img v-if="app_locale == 'no'" src="../assets/images/languages/en.svg" />
                                    <img v-else src="../assets/images/languages/no.svg" />
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="menu-toggle visible-mobile" v-on:click="toogleNavVisible">
                        <span class="material-symbols-outlined" style="font-size: 32px;">menu</span>
                    </div>
                </div>
            </div>
        </div>


        <div style="position: relative; flex:1 0 auto; display: flex; align-items: stretch;">
            <router-view />
        </div>
        <div class="footer">
            <div class="footer-container">
                <div class="footer-left">
                    <p class="h1">
                        <a href="tel:177">
                            <img class="circle circle-large" src="../assets/images/phone-177-circle-white.svg" />
                        </a>
                    </p>
                    <div>
                        <p class="footer-text">{{ $t('footer.phone') }}</p>
                        <p class="footer-text">{{ $t('footer.desc') }}</p>
                    </div>
                </div>
                <div style="flex-grow: 1;"></div>
                <div class="footer-right">
                    <p class="footer-text company-name">
                        Kolumbus AS
                    </p>
                    <p class="footer-text">
                        {{ $t('footer.orgnization_number') }}
                    </p>
                </div>


            </div>
        </div>
        <div v-if="authenticated">
            <div id="n1-inactive-modal" class="w3-modal" style="display: block;" v-if="logout_warning_modal_visible">
                <div class="w3-modal-content w3-card-4" style="max-width:500px;position:relative;">
                    <div class="w3-container">
                        <h4 class="n2-text-center">{{ $t('layout.text_inactive_header') }}</h4>
                        <p>{{ $t('layout.text_inactive_message1') }} {{ count_down }} {{
                            $t('layout.text_inactive_message2') }}</p>
                        <p>{{ $t('layout.text_inactive_message3') }}</p>
                        <div class="n2-text-center n2-margin">
                            <button v-on:click="keepLogged($event)" class="n2-button-1">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="n1-auto-logged-out" class="w3-modal" style="display: block;" v-if="loggged_out_modal_visible">
            <div class="w3-modal-content w3-card-4" style="max-width:500px;position:relative;">
                <div class="w3-container">
                    <h4 class="n2-text-center">{{ $t('layout.text_auto_signed_out_title') }}</h4>
                    <p class="n2-text-center">{{ $t('layout.text_auto_signed_out_description') }}</p>
                    <div class="n2-text-center n2-margin">
                        <button v-on:click="consentLoggedOutMessage()" class="n2-button-1">OK</button>
                    </div>
                </div>
            </div>
        </div>
        <div id="n1-signin-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">

                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>

                <div class="w3-container">
                    <signin></signin>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Signin from '../components/app/signin.vue'
import { IdentityService } from '../services'



export default {
    name: 'MainLayout',
    components: {
        Signin
    },
    data() {
        return {
            count_down: 0,
            warning_timer: null,
            logout_timer: null,
            count_down_timer: null,
            // inactive_time_before_warn: 1000 * 10,
            // warning_time_before_logout: 1000 * 5,
            inactive_time_before_warn: 1000 * 60 * 15,
            warning_time_before_logout: 1000 * 45,
            logout_warning_modal_visible: false,
            loggged_out_modal_visible: false
        }
    },
    computed: {
        ...mapGetters('identity', [
            'authenticated',
            'last_active_time',
            'signed_in_time',
            'stay_signed_in'
        ]),
        ...mapGetters('app_settings', [
            'nav_bar_visible'
        ]),
        ...mapGetters('globalization', [
            'app_locale',
            'language',
            'languages'
        ]),
        the_other_language: function () {
            return this.app_locale == 'en' ? 'Norsk' : 'English'
        },
    },
    watch: {
        'signed_in_time': function () {
            this.startWarningTimer();
        }
    },
    created: async function () {
        this.identityService = new IdentityService();

        await this.checkLastActiveTime();

        this.startWarningTimer();

    },
    beforeMount: function () {

        window.addEventListener("click", this.startWarningTimer);
        window.addEventListener("keydown", this.startWarningTimer);
    },
    mounted: async function () {
        await this.checkToken();

    },
    beforeDestroy: function () {
        window.removeEventListener("click", this.startWarningTimer);
        window.removeEventListener("keydown", this.startWarningTimer);
        this.clearTimers();
    },
    methods: {
        checkLastActiveTime: async function () {
            if (this.authenticated) {
                let compareTimeLogout = new Date(new Date(this.last_active_time).getTime() + this.inactive_time_before_warn + this.warning_time_before_logout);
                if (!this.last_active_time || new Date() > compareTimeLogout) {
                    if (!this.stay_signed_in) {
                        await this.signOut();
                    }
                }
            }
        },
        clearTimers: function () {
            if (this.warning_timer) {
                clearTimeout(this.warning_timer);
                this.warning_timer = null;
            }
            if (this.logout_timer) {
                clearTimeout(this.logout_timer);
                this.logout_timer = null;
            }
            if (this.count_down_timer) {
                clearInterval(this.count_down_timer);
                this.count_down_timer = null;
            }
        },
        startLogoutTimer: function () {
            if (this.authenticated) {
                this.clearTimers();
                this.openLogoutModal();
                this.countDown();
                this.count_down_timer = setInterval(this.countDown, 1000);
                this.logout_timer = setTimeout(this.autoSignOut, this.warning_time_before_logout);
            }
        },
        autoSignOut: async function () {
            await this.signOut();
            this.loggged_out_modal_visible = true;

        },
        startWarningTimer: async function () {
            if (!this.logout_warning_modal_visible) {
                this.clearTimers();
                if (this.authenticated) {
                    this.$store.dispatch('identity/refresh_last_active');
                    if (!this.stay_signed_in) {
                        this.warning_timer = setTimeout(this.startLogoutTimer, this.inactive_time_before_warn);
                    }
                }
            }
        },
        consentLoggedOutMessage: function () {
            this.loggged_out_modal_visible = false;
        },
        openLogoutModal: function () {
            this.logout_warning_modal_visible = true;
        },
        checkToken: async function () {
            let authedUntil = await this.$store.dispatch('identity/get_authenticated_until');
            if (this.authenticated) {
                if (!authedUntil || new Date() > new Date(authedUntil)) {
                    await this.signOut();
                }
            }
            else if (authedUntil) {
                await this.signOut();
            }
        },
        countDown: async function () {
            if (this.authenticated && this.last_active_time) {
                let compareTimeLogout = new Date(new Date(this.last_active_time).getTime() + this.inactive_time_before_warn + this.warning_time_before_logout);
                this.count_down = Math.floor((compareTimeLogout - new Date()) / 1000);
            }
        },
        changeLanguage() {
            let locale = this.app_locale == 'en' ? 'no' : 'en'
            if (locale !== this.$route.params.lang) {
                const to = this.$router.resolve({ params: { lang: locale }, query: this.$route.query })
                let p = to.location.path;
                if (p.length > 1 && p.slice(-1) == '/') {
                    p = p.substr(0, p.length - 1);
                }
                this.$router.push({ path: p, query: this.$route.query })
            }
        },
        toogleNavVisible: async function () {
            this.$store.commit('app_settings/set_nav_bar_visible', !this.nav_bar_visible);
        },
        keepLogged: async function () {
            this.logout_warning_modal_visible = false;
            this.startWarningTimer();
        },
        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        },
        signOut: async function () {
            this.clearTimers();
            this.logout_warning_modal_visible = false;
            this.$store.commit('app_settings/set_nav_bar_visible', false);

            try {
                await this.$store.dispatch('identity/signout');
                if (this.$route.path.split('/').some(a => a == 'account')) {
                    this.$router.push({
                        path: '/' + this.app_locale
                    });
                }
            }
            catch {
                this.model_errors = { sign_in: [this.$t('components.signin.error_sign_out')] }
            }

        }
    }
}
</script>
